export default "__VITE_ASSET__gjM28Ahz__"